
const $slider_node_type2 = $(".js-slider-type2");

if($slider_node_type2.length){

    $slider_node_type2.owlCarousel({
        loop:true,
        margin:24,
        nav: true,
        dots: false,
        items: 1,
        smartSpeed: 1000,
        navText: ["<svg><use href='#arrow-left-long'></use></svg>",
            "<svg><use href='#arrow-right-long'></use></svg>"],
    })
}

